export enum BrandTypesEnum {
    SILENTCLOUD="SILENTCLOUD",
    AUDIONOVA="AUDIONOVA",
    SCHOONENBERG="SCHOONENBERG",
    LAPPERRE="LAPPERRE",
    CONNECTHEARING="CONNECTHEARING",
    BOOTSHEARINGCARE="BOOTSHEARINGCARE",
    AUDIONOVAUS="AUDIONOVAUS",
    PHONAKGS="PHONAKGS"
}
